import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: "16px 24px",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width: "900px",
    maxWidth: "none",
    height: "85vh",
  },
}));

interface ViewDocumentDialogProps {
  isOpen: boolean;
  handleClose: () => void;
  documentName: string;
  fileUrl: string;
  fileType: string;
}

const IMAGE_TYPES = ["PNG", "JPG", "JPEG", "GIF", "BMP", "SVG"];

export default function ViewDocumentDialog({
  isOpen = false,
  handleClose,
  documentName,
  fileUrl,
  fileType,
}: ViewDocumentDialogProps) {
  const normalizedType = fileType?.toUpperCase() || "";
  const isImage =
    IMAGE_TYPES.includes(normalizedType) || normalizedType.includes("IMAGE");

  return (
    <BootstrapDialog
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          handleClose();
        }
      }}
      aria-labelledby="view-document-dialog-title"
      open={isOpen}
    >
      <DialogTitle
        sx={{
          m: 0,
          p: 2,
          fontWeight: 600,
          fontSize: "18px",
          fontFamily: "inter",
        }}
        id="view-document-dialog-title"
      >
        {documentName || "View Document"}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <hr />

      <DialogContent
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "16px 24px",
          overflow: "hidden",
        }}
      >
        {fileUrl ? (
          isImage ? (
            <Box
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "auto",
              }}
            >
              <img
                src={fileUrl}
                alt={documentName}
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                }}
              />
            </Box>
          ) : (
            <iframe
              src={fileUrl}
              title={documentName}
              style={{
                width: "100%",
                height: "100%",
                border: "none",
              }}
            />
          )
        ) : (
          <Typography
            sx={{
              fontFamily: "inter",
              fontSize: "14px",
              color: "#9E9E9E",
            }}
          >
            Unable to load document preview.
          </Typography>
        )}
      </DialogContent>
    </BootstrapDialog>
  );
}
